import React, { PureComponent } from 'react';

import Icon from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Popover } from 'antd';

import { ReactComponent as ToolboxQuestionIconSVG } from '../../../../assets/sightx-icons/svg/sx-toolbox-question.svg';
import { isNetquestClient, isPureProfileClient } from '../../../../utils/clients';

import styles from './index.module.scss';

interface IGetHelpState {
  popupOpened: boolean;
}

export class GetHelp extends PureComponent<Record<string, never>, IGetHelpState> {
  constructor(props: Record<string, never>) {
    super(props);
    this.handleUserPilotTrigger = this.handleUserPilotTrigger.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.state = {
      popupOpened: false
    };
  }
  private handleUserPilotTrigger() {
    if (!userpilot) {
      return;
    }
    userpilot.trigger('resource_center:kR3Dp8qsAG');
    return;
  }

  private onVisibilityChange(value: boolean) {
    this.setState({
      popupOpened: value
    });
  }

  private renderPureProfilePopupContent() {
    const supportEmail = 'support@datarubico.com';
    const feedbackEmail = 'feedback@datarubico.com';
    return <div className={styles.emails}>
      <div className={styles.email}>
        <span className={styles.label}>Access to: </span>
        <a className={styles.link} href='https://support.sightx.io/knowledge' rel='noreferrer' target='_blank'>Knowledge Base</a>
      </div>
      <div className={styles.email}>
        <span className={styles.label}>For support: </span>
        <Link
          className={styles.link}
          to="#"
          onClick={(e) => {
            window.location.href = `mailto:${supportEmail}`;
            e.preventDefault();
          }}
        >
          {supportEmail}
        </Link>
      </div>
      <div className={styles.email}>
        <span className={styles.label}>For feedback: </span>
        <Link
          className={styles.link}
          to="#"
          onClick={(e) => {
            window.location.href = `mailto:${feedbackEmail}`;
            e.preventDefault();
          }}
        >
          {feedbackEmail}
        </Link>
      </div>
    </div>;
  }

  private renderNetquestPopupContent() {
    const europeEmail = 'flashsurvey.europa@netquest.com';
    const americaEmail = 'flashsurvey.americas@netquest.com';
    return <div className={styles.emails}>
      <div className={styles.email}>
        <span className={styles.label}>Europe: </span>
        <Link
          className={styles.link}
          to='#'
          onClick={(e) => {
            window.location.href = `mailto:${europeEmail}`;
            e.preventDefault();
          }}
        >
          {europeEmail}
        </Link>
      </div>
      <div className={styles.email}>
        <span className={styles.label}>America: </span>
        <Link
          className={styles.link}
          to='#'
          onClick={(e) => {
            window.location.href = `mailto:${americaEmail}`;
            e.preventDefault();
          }}
        >
          {americaEmail}
        </Link>
      </div>
    </div>;
  }

  render(): JSX.Element {
    if (isNetquestClient() || isPureProfileClient()) {
      const { popupOpened } = this.state;
      return <Popover
        overlayClassName={styles.userConfigMenuPopup}
        trigger="click"
        visible={popupOpened}
        onVisibleChange={this.onVisibilityChange}
        content={isPureProfileClient() ? this.renderPureProfilePopupContent() : this.renderNetquestPopupContent()}
        placement='right'
      >
        <span className={styles.getHelp}>
          <Icon component={ToolboxQuestionIconSVG} />
        </span>
      </Popover>;
    }

    return (
      <span className={styles.getHelp} onClick={this.handleUserPilotTrigger}>
        <Icon component={ToolboxQuestionIconSVG} />
      </span>
    );
  }
}
